(function($) {
    'use strict';

    $.fn.compareStatistic = function () {
        const $self = $(this);
        const $path = $self.find('.js-path');
        const $svg = $self.find('.js-svg');

        /**
         * Установить атрибуты путей
         */
        const setPathAttributes = () => {
            $path.each(function () {
                const totalLength = $(this).get(0).getTotalLength();
                $(this).css({
                    'stroke-dashoffset': totalLength,
                    'stroke-dasharray' : totalLength
                });
            })
        };

        /**
         * Заполнить график
         */
        const fulfillGraphic = () => {
            $svg.each(function () {
                const path = $(this).find('.js-path').get(0);
                const percents = $(this).data('games') / $(this).data('totalGames') * 100;
                const totalLength = path.getTotalLength();
                const lengthToSet = totalLength / 100 * percents;
                $(path).css({
                    'stroke-dashoffset':  totalLength + lengthToSet
                });
            });
        };

        const init = function () {
            setPathAttributes();
            fulfillGraphic();
        };

        init();

        return this;
    };
})(jQuery);
